import React from 'react';
import { Link } from 'react-router-dom';

import './index.css';

const NotFound = () => (
  <div className="notfound view">
    <h1 className="notfound__title">Not found</h1>
    <h2 className="notfound__subtitle">Sorry this page doesn't exist!</h2>
    <Link to="/">Return Home</Link>
  </div>
);

export default NotFound;
